import React from 'react';
import styled from 'styled-components';
import { Flex, small, TextWithTooltip } from '@ubeya/shared-web/components';

const Chip = styled(TextWithTooltip)`
  ${small}
  max-width: 50px;
  margin: 2px;
  background: ${({ theme, $color }) => $color || theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 3px;
  padding: 1px 3px;
`;

const Tags = styled(Flex)`
  flex-wrap: wrap;
  margin-left: -2px;
  padding: 5px;
`;

const TagsRenderer = ({ rowData: { summarized, tags }, columnData: { mappedTags } }) => {
  if (summarized || !tags) {
    return <></>;
  }

  return (
    <Tags>
      {tags.map(({ id }) => (
        <Chip key={id} $color={mappedTags[id]?.color}>
          {mappedTags[id]?.label}
        </Chip>
      ))}
    </Tags>
  );
};

export default TagsRenderer;
